module.exports = __webpack_public_path__ + "static/media/spooky-loader.2dd51f66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/spooky-loader.svg
// module id = 1260
// module chunks = 1